import { render, staticRenderFns } from "./BreadDataTableTabChild.vue?vue&type=template&id=bae3bb18&scoped=true&"
import script from "./BreadDataTableTabChild.vue?vue&type=script&lang=js&"
export * from "./BreadDataTableTabChild.vue?vue&type=script&lang=js&"
import style0 from "./BreadDataTableTabChild.vue?vue&type=style&index=0&id=bae3bb18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae3bb18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
